module.exports = __webpack_public_path__ + "img/tarixiy1.b089b348.jpg";